import { render, staticRenderFns } from "./DetialOfAttidute.vue?vue&type=template&id=9c18305a&scoped=true"
import script from "./DetialOfAttidute.vue?vue&type=script&lang=js"
export * from "./DetialOfAttidute.vue?vue&type=script&lang=js"
import style0 from "./DetialOfAttidute.vue?vue&type=style&index=0&id=9c18305a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c18305a",
  null
  
)

export default component.exports